import React, { useState } from 'react';
import PlusIcon from '@heroicons/react/outline/PlusIcon.js';
import { T, useI18n } from '@tribeplatform/react-components/i18n';
import { LinkFieldPicker, ImagePickerBlockField, } from '@tribeplatform/react-components/PickerField';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { SortableList } from '@tribeplatform/react-ui-kit/SortableList';
import { useBlock } from '../../hooks/index.js';
export const LinkMenuBlockSettings = () => {
    const { $t } = useI18n();
    const { block: { props: { items, title }, }, upsertProp, } = useBlock();
    const [activeIndex, setActiveIndex] = useState(0);
    const addItem = () => {
        const newItems = [...items, {}];
        const index = newItems.length - 1;
        upsertProp('items', newItems);
        setActiveIndex(index);
    };
    const deleteItem = (items, key, itemIndex) => {
        upsertProp(key, [
            ...items.slice(0, itemIndex),
            ...items.slice(itemIndex + 1),
        ]);
    };
    const editItem = (index, key, value) => {
        const newItems = [...items];
        newItems[index][key] = value;
        upsertProp(`items`, newItems);
        setActiveIndex(index);
    };
    const onDragEnd = (items, key) => result => {
        if (!result.destination) {
            return;
        }
        const newItems = SortableList.reorder(items, result.source.index, result.destination.index);
        upsertProp(key, newItems);
    };
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(FormControl.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }), value: title, onChange: e => upsertProp('title', e.target.value) }),
        React.createElement(SortableList, { onDragEnd: onDragEnd(items, 'items'), items: items.map((it, index) => (Object.assign(Object.assign({}, it), { id: index }))), renderItem: (item, index) => (React.createElement(SortableList.Item, { id: item.id }, index === activeIndex ? (React.createElement("div", { className: "space-y-3 bg-surface-subdued p-3 rounded-md" },
                React.createElement("div", { className: "flex items-center space-s-2" },
                    React.createElement(SortableList.Handle, null),
                    React.createElement("span", { className: "truncate" }, item.text || 'Link text')),
                React.createElement(FormControl, null,
                    React.createElement(FormControl.Label, null,
                        React.createElement(T, { id: "Generics.Image", defaultMessage: "Image" })),
                    React.createElement(ImagePickerBlockField, { image: item.image, removable: true, onChange: image => {
                            editItem(index, 'image', image);
                        } })),
                React.createElement(FormControl.Input, { name: "text", label: "Text", value: item.text, onChange: e => editItem(index, 'text', e.target.value) }),
                React.createElement(LinkFieldPicker, { onChange: (href, openInNewWindow) => {
                        if (item.href === href) {
                            editItem(index, 'openInNewWindow', openInNewWindow);
                        }
                        else {
                            editItem(index, 'href', href);
                        }
                    }, name: "href", label: $t({ id: 'Generics.Link', defaultMessage: 'Link' }), value: item.href, openInNewWindow: item.openInNewWindow }),
                React.createElement(Button, { variant: "outline", onClick: () => deleteItem(items, 'items', index) },
                    React.createElement(T, { id: "Generics.Remove", defaultMessage: "Remove" })))) : (React.createElement("div", { className: "bg-surface-subdued p-3 rounded-md cursor-pointer flex items-center space-s-2", onClick: () => setActiveIndex(index) },
                React.createElement(SortableList.Handle, null),
                React.createElement("span", { className: "truncate" }, item.text || (React.createElement(T, { id: "Blocks.LinkMenu.DefaultLinkText", defaultMessage: "Link text" }))))))) }),
        React.createElement(Button, { variant: "outline", onClick: () => addItem(), fullWidth: true, leadingIcon: React.createElement(PlusIcon, null) },
            React.createElement(T, { id: "Blocks.LinkMenu.AddLinkButton", defaultMessage: "Add link" }))));
};
//# sourceMappingURL=Settings.js.map